import React from 'react';
import { WorkflowCanvas } from '../components/Workflow/WorkflowCanvas';

const CreateWorkflow = () => {
  return (
    <div className="flex flex-1 min-h-0 h-full bg-paper">
      <div className="flex-1 flex flex-col min-h-0">
        <WorkflowCanvas />
      </div>
    </div>
  );
};

export default CreateWorkflow;
